import { render, staticRenderFns } from "./PropertyAddress.vue?vue&type=template&id=6b98c5d5"
import script from "./PropertyAddress.vue?vue&type=script&lang=js"
export * from "./PropertyAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports